const priceFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
})

const timeFormatter = new Intl.NumberFormat('fr-FR', {
  minimumIntegerDigits: 2,
})

export const formatPrice = (value?: number | null) => {
  if (typeof value !== 'number' || Number.isNaN(value)) return 'N/A'
  return priceFormatter.format(value)
}

export const formatSeconds = (milliseconds: number) => {
  const safeValue = Number.isFinite(milliseconds) && milliseconds > 0 ? milliseconds : 0
  const totalSeconds = Math.floor(safeValue / 1000)
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${timeFormatter.format(seconds)}`
}
